import { render, staticRenderFns } from "./NewRirekishoRequestsCard.vue?vue&type=template&id=e7268640&scoped=true"
import script from "./NewRirekishoRequestsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoRequestsCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoRequestsCard.vue?vue&type=style&index=0&id=e7268640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7268640",
  null
  
)

export default component.exports